import { getStringAttributeValue } from '../../../util'
import { getFirstNotEmpty } from '@corratech/pylot-utils'
import { Maybe, ProductInterface } from '@pylot-data/fwrdschema'
import { PylotFrontendConfig } from 'config'
import { translateRatingToDecimal } from '@lib/utils/translateRatingToDecimal'

/**
 * @see https://schema.org/AggregateRating
 * Get AggregateRating object
 * If review_count is empty, it means that the rating data is missing or invalid
 * If best rating is not available, we can use rounded rating value.
 *
 * @param product
 */
export const getAggregateRating = (
    product: ProductInterface,
    config: PylotFrontendConfig
): Maybe<Record<string, Record<string, string>>> => {
    const reviewCount = getStringAttributeValue(product, 'review_count', config)
    const reviewCountNumber = Number(reviewCount)
    if (
        !reviewCount ||
        Number.isNaN(reviewCountNumber) ||
        reviewCountNumber <= 0
    ) {
        return {}
    }
    const ratingValue = getStringAttributeValue(
        product,
        'review_summary',
        config,
        '0'
    )
    const bestRatingValue = getFirstNotEmpty(
        [config.seo.product?.bestRating, Math.ceil(Number(ratingValue))],
        false
    )

    const ratingTotal =
        product && translateRatingToDecimal(product?.rating_summary)

    if (!ratingTotal || Number(ratingTotal) <= 0) {
        return {}
    }

    return {
        aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: String(ratingTotal),
            reviewCount: String(reviewCount),
            bestRating: String(bestRatingValue),
            worstRating: String(1)
        }
    }
}
